import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ad9949"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "modal-title" }, "メールアドレス指定", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_4 = { class: "email-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "To", -1))
const _hoisted_6 = { class: "email-inputs" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { class: "email-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "Cc", -1))
const _hoisted_10 = { class: "email-inputs" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "email-section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "email-label" }, "Bcc", -1))
const _hoisted_14 = { class: "email-inputs" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "modal-content",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        _hoisted_2,
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses.to, (email, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("input", {
                key: `to-${index}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.addresses.to[index]) = $event),
                type: "email",
                class: "email-input",
                placeholder: "メールアドレスを入力",
                onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cleanupEmptyFields('to')))
              }, null, 40, _hoisted_7)), [
                [_vModelText, _ctx.addresses.to[index]]
              ])
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses.cc, (email, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("input", {
                key: `cc-${index}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.addresses.cc[index]) = $event),
                type: "email",
                class: "email-input",
                placeholder: "メールアドレスを入力",
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cleanupEmptyFields('cc')))
              }, null, 40, _hoisted_11)), [
                [_vModelText, _ctx.addresses.cc[index]]
              ])
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses.bcc, (email, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("input", {
                key: `bcc-${index}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.addresses.bcc[index]) = $event),
                type: "email",
                class: "email-input",
                placeholder: "メールアドレスを入力",
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cleanupEmptyFields('bcc')))
              }, null, 40, _hoisted_15)), [
                [_vModelText, _ctx.addresses.bcc[index]]
              ])
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
            class: "btn btn-cancel"
          }, " 通知をやめて登録/返信処理を完了する "),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleOk && _ctx.handleOk(...args))),
            class: "btn btn-ok"
          }, "決定")
        ])
      ])
    ])
  ]))
}